<template>
  <section class="post-section">
    <h3 class="post-section__title">Dados do remetente</h3>
    <el-form :model="ruleForm" ref="ruleForm" label-position="top" class="post-form">
      <el-form-item v-if="userType === '1' || userType === '3'" :label="$t('cliente')" prop="customer">
        <CustomerList
          ref="customerList"
          v-model="ruleForm.customer"
          :current="[ruleForm.customer]"
          :customerType="userType === '1' ? 0 : 1"
          v-on:selected="selected"
        />
      </el-form-item>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="12">
          <el-form-item :label="$t('nome')" prop="name" class="is-required">
            <el-input maxlength="50" v-model="ruleForm.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item :label="$t('cpf/cnpj')" prop="active">
            <el-input v-mask="['NNN.NNN.NNN-NN', 'NN.NNN.NNN/NNNN-##']" v-model="ruleForm.federalid"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="6">
          <el-form-item :label="$t('cep')" prop="cep">
            <el-input
              maxlength="9"
              v-model="ruleForm.zipcode"
              v-mask="'#####-###'"
              v-loading="loading"
              @blur="zipcode()"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="18">
          <el-form-item :label="$t('endereco')" prop="address" :required="true">
            <el-input maxlength="50" v-model="ruleForm.address"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="12" :md="10">
          <el-form-item :label="$t('bairro')" prop="neighborhood" :required="true">
            <el-input v-model="ruleForm.neighborhood" maxlength="40"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="8" :md="8">
          <el-form-item :label="$t('cidade')" prop="city" :required="true">
            <el-input v-model="ruleForm.city" maxlength="40"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="4" :md="6">
          <el-form-item :label="$t('estado')" prop="state" :required="true">
            <el-input v-model="ruleForm.state" maxlength="2"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="6">
          <el-form-item :label="$t('numero')" prop="name" class="is-required">
            <el-input maxlength="6" v-model="ruleForm.number"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="18">
          <el-form-item :label="$t('complemento')" prop="active">
            <el-input maxlength="40" v-model="ruleForm.complement"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </section>
</template>
<script>
import { UserService } from "@/services/users/user.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import { PostOfficeService } from "@/services/post.office/post.office.services";

export default {
  name: "PostSender",
  components: {
    CustomerList,
  },
  methods: {
    setup(form, data) {
      this.ruleForm.customer = form.customer;
      this.ruleForm.zipcode = form.sourceZipcode;
      if (this.ruleForm.zipcode) {
        this.zipcode();
      }
    },
    selected(id, customer) {
      console.log("sender", id, customer);
      if (customer) {
        this.ruleForm.federalid = customer.federalid;
      }
    },
    zipcode() {
      const vm = this;
      this.loading = true;
      PostOfficeService.zipcode(vm.ruleForm.zipcode)
        .then((response) => {
          vm.ruleForm.address = response.end;
          vm.ruleForm.city = response.cidade;
          vm.ruleForm.state = response.uf;
          vm.ruleForm.neighborhood = response.bairro;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: i18n.tc("cep-invalido"),
            duration: 5000,
          });
        })
        .finally(() => (this.loading = false));
    },
  },
  data() {
    return {
      userType: "2",
      loading: false,
      ruleForm: {
        name: "",
        federalid: "",
        zipcode: "",
        address: "",
        neighborhood: "",
        city: "",
        state: "",
        number: "",
        complement: "",
        customer: "",
      },
    };
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.userType = response.type;
        vm.ruleForm.name = response.name;
        console.log("me, ", response);
        if (response.customers) vm.ruleForm.federalid = response.customers.federalid;
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
